import { getKeysAsDictionary } from '@core/util';
import { VerificationApplicationModel } from '../model/verification-application.model';
import { LoanCalculatorModel } from '../model/loan-calculator.model';
import { LeadFormModel } from '../model/lead.model';

export const LoanCalculatorModelKey = getKeysAsDictionary(LoanCalculatorModel);
export const VerificationApplicationModelKey = getKeysAsDictionary(VerificationApplicationModel);
export const LeadFormModelKey = getKeysAsDictionary(LeadFormModel);
